// src/components/Products/FeedbackForm/services/api.js
import api from '../../../../services/api';

/**
 * Endpoints base do produto
 */
const basePath = '/feedback-form';

/* =========================
 *   PERGUNTAS (Admin)
 * ========================= */

export async function listQuestions(restauranteId, ativos) {
  const res = await api.get(`${basePath}/perguntas`, {
    params: { restauranteId, ativos },
  });
  return res.data;
}

export async function getQuestion(id) {
  const res = await api.get(`${basePath}/perguntas/${id}`);
  return res.data;
}

export async function createQuestion(payload) {
  const res = await api.post(`${basePath}/perguntas`, payload);
  return res.data;
}

export async function updateQuestion(id, payload) {
  const res = await api.patch(`${basePath}/perguntas/${id}`, payload);
  return res.data;
}

export async function deleteQuestion(id) {
  const res = await api.delete(`${basePath}/perguntas/${id}`);
  return res.data;
}

export async function reorderQuestions(perguntas) {
  const res = await api.post(`${basePath}/perguntas/reorder`, { perguntas });
  return res.data;
}

/* =========================
 *   SESSÕES (Admin)
 * ========================= */

export async function listSessions(restauranteId, params = {}) {
  const res = await api.get(`${basePath}/clientes`, {
    params: { restauranteId, ...params },
  });
  return res.data;
}

export async function getSession(id) {
  const res = await api.get(`${basePath}/clientes/${id}`);
  return res.data;
}

export async function startSession(restauranteId, cliente_telefone, cliente_nome) {
  const res = await api.post(`${basePath}/clientes/iniciar`, {
    restauranteId,
    cliente_telefone,
    cliente_nome,
  });
  return res.data;
}

export async function finishSession(restauranteId, id) {
  const res = await api.post(`${basePath}/clientes/${id}/finalizar`, {
    restauranteId,
  });
  return res.data;
}

export async function deleteSession(id) {
  const res = await api.delete(`${basePath}/clientes/${id}`);
  return res.data;
}

/* =========================
 *   RESPOSTAS (Admin)
 * ========================= */

export async function submitAnswers({ restauranteId, clienteId, itens }) {
  const res = await api.post(`${basePath}/respostas`, {
    restauranteId,
    clienteId,
    itens,
  });
  return res.data;
}

/* =========================
 *   ANALYTICS (Admin)
 * ========================= */

export async function getAnalyticsSummary(restauranteId, from, to) {
  const res = await api.get(`${basePath}/analytics/resumo`, {
    params: { restauranteId, from, to },
  });
  return res.data;
}

export async function getAnalyticsDetails(
  restauranteId,
  perguntaId,
  page = 1,
  limit = 20
) {
  const res = await api.get(`${basePath}/analytics/detalhes`, {
    params: { restauranteId, perguntaId, page, limit },
  });
  return res.data;
}

/* =========================
 *   GOOGLE LINK (Admin)
 * ========================= */

export async function getGoogleLink() {
  const res = await api.get(`${basePath}/google-link`);
  return res.data; // { google_review_url }
}

export async function patchGoogleLink({ google_review_url }) {
  const res = await api.patch(`${basePath}/google-link`, { google_review_url });
  return res.data; // { google_review_url }
}

/* =========================
 *   ENDPOINTS PÚBLICOS
 * ========================= */

export async function publicListQuestions(restauranteId, ativos = true) {
  const res = await api.get(`${basePath}/public/perguntas`, {
    params: { restauranteId, ativos },
  });
  return res.data;
}

export async function publicStartSession(
  restauranteId,
  cliente_telefone,
  cliente_nome
) {
  const res = await api.post(`${basePath}/public/clientes/iniciar`, {
    restauranteId,
    cliente_telefone,
    cliente_nome,
  });
  return res.data;
}

export async function publicSubmitAnswers({ restauranteId, clienteId, itens }) {
  const res = await api.post(`${basePath}/public/respostas`, {
    restauranteId,
    clienteId,
    itens,
  });
  return res.data;
}

export async function publicFinishSession(restauranteId, clienteId) {
  const res = await api.post(
    `${basePath}/public/clientes/${clienteId}/finalizar`,
    { restauranteId }
  );
  return res.data;
}

export async function publicSaveFeedback({
  restauranteId,
  clienteId,
  nota,
  comentario,
  cliente_nome,
  cliente_telefone,
}) {
  const res = await api.post(`${basePath}/public/feedbacks`, {
    restauranteId,
    clienteId,
    nota,
    comentario,
    cliente_nome,
    cliente_telefone,
  });
  return res.data;
}

/* =========================
 *   DEFAULT EXPORT
 * ========================= */
const feedbackFormApi = {
  // perguntas
  listQuestions,
  getQuestion,
  createQuestion,
  updateQuestion,
  deleteQuestion,
  reorderQuestions,
  // sessões
  listSessions,
  getSession,
  startSession,
  finishSession,
  deleteSession,
  // respostas / analytics
  submitAnswers,
  getAnalyticsSummary,
  getAnalyticsDetails,
  // google link
  getGoogleLink,
  patchGoogleLink,
  // públicos
  publicListQuestions,
  publicStartSession,
  publicSubmitAnswers,
  publicFinishSession,
  publicSaveFeedback,
};

export default feedbackFormApi;
